var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    {
      staticClass: "d-inline-block quick-cart__remove-items",
      attrs: { href: _vm.removeItemLink },
      on: {
        click: function($event) {
          $event.preventDefault()
          return _vm.removeItem.apply(null, arguments)
        }
      }
    },
    [_c("small", [_vm._v(_vm._s(_vm.removeText))])]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }